import React from 'react'
import { cn, Icon, InputTextarea, Modal, PrimaryButton, Text } from '@artprov/design-system'
import { yupResolver } from '@hookform/resolvers/yup'
import { Controller, useForm } from 'react-hook-form'
import { comentarioSchema } from '../../../../../schemas/comentarioRechazar.schema'

export default function ModalRechazar({ open, setOpen, text = "", textAreaConfig = {}, handleValue = (values) => console.log(values) }) {
    const handleValues = handleValue

    const handleClose = () => setOpen(false)

    return (
        <Modal.Container open={open} className={cn("min-h-[294px]")} onClose={handleClose}>
            <Modal.Content className={cn("min-h-[494px]")}>
                <div className={cn("flex justify-between items-start h-20 ")}>
                    <div className="size-14" />
                    <Icon
                        icon="Error"
                        className="py-4"
                        classNameIcon={cn("text-warning-10")}
                        size="extra-large"
                    />
                    <Modal.Close
                        onClose={handleClose}
                    />
                </div>
                <Modal.Title className={cn("flex flex-col items-center")}>Rechazar solicitud</Modal.Title>
                <Text variant="body1" className={cn("text-tertiary-10 px-4 h-min flex text-center w-full",)}>
                    {text}
                </Text>
                <FormularioRechazar textAreaConfig={textAreaConfig} handleValue={handleValues} handleClose={handleClose} />
            </Modal.Content>
        </Modal.Container >
    )
}

const FormularioRechazar = ({ handleValue, handleClose, textAreaConfig = {} }) => {

    const method = useForm({
        resolver: yupResolver(comentarioSchema),
        mode: "onChange",
        delayError: 500,
        defaultValues: { comentario: "" },
    })

    const { handleSubmit, control, formState: { isSubmitting, isValid } } = method

    return (
        <form onSubmit={handleSubmit(handleValue)} className='px-5'>
            <Controller
                control={control}
                name="comentario"
                render={({ field }) => (
                    <InputTextarea
                        placeholder={textAreaConfig?.placeholder || ""}
                        label={textAreaConfig?.label || ""}
                        isRequired={textAreaConfig?.isRequired || false}
                        onChange={(e) => {
                            field.onChange(e)
                        }}
                    />
                )} />
            <div className='flex justify-center mt-3'>
                <Modal.CancelButton onClick={handleClose}>Cancelar</Modal.CancelButton>
                <PrimaryButton disabled={!isValid}>Rechazar solicitud</PrimaryButton>
            </div>
        </form>
    )
}
